import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'experts-choice-badge',
  templateUrl: './experts-choice-badge.component.html',
  styles: [':host { display: contents; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpertsChoiceBadgeComponent {}
